unable to read source [project]/frontend/node_modules/src/camera/permissions.ts